import { IEnvironment } from "./IEnvironment";

export const environment: IEnvironment  = {
  production: false,
  name: 'moe',
  api_base: '/api',
  main_page_title: 'Monsuivi-MOE'
}
